import { PaintStyle, LineStyle, Color, LineKinds, TextureKinds } from "../../drawing";
import { AbstractRectangleItem } from "./AbstractRectangleItem";
import { IShapeDrawable } from "./IShapeDrawable";

export abstract class AbstractPaintableItem extends AbstractRectangleItem implements IShapeDrawable {
  constructor(typeKey: string) {
    super(typeKey);
  }

  public lineStyle: LineStyle = new LineStyle(new Color("#000000"), LineKinds.Normal, 2);
  public paintStyle: PaintStyle = new PaintStyle(new Color("#000000"), TextureKinds.None);

  protected applyMembers(clone: AbstractPaintableItem): void {
    super.applyMembers(clone);
    clone.lineStyle = this.cloneValue(this.lineStyle);
    clone.paintStyle = this.cloneValue(this.paintStyle);
  }
}
